import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EditBlogLayer from "../components/EditBlogLayer";

const EditBlogPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Blog Edit' />

        {/* AddBlogLayer */}
        <EditBlogLayer />
      </MasterLayout>
    </>
  );
};

export default EditBlogPage;
